import Model from '../../model/model';
import RefBooksList from './refbooks.list';
import Type from '../../model/newstype';
import TypeFormTemplate from './types.form.template';
import Types from '../../collection/refbooks/types';

import Config from '../../config';

import { roleA, roleAC, roleAI } from '../../roles';
import { restrict, } from '../../model/actions';
import { ask, } from '../../utils/popups';




const FilterModel = Model.extend( { defaults: {
    cluster: undefined,
} } )

export default RefBooksList.extend( { 

    template: 'module/refbooks/types.list',

    url() {
        return 'types';
    },

    open() {
        const actions = this.options.actions = {
            
            defaults: 'edit',

            create: restrict( roleAC, 
                () => this.trigger( TypeFormTemplate.OPEN_TYPE, 
                    new Type(), 
                    this.state().cluster ) ),
            
            edit: restrict( roleAC,
                current => this.trigger( TypeFormTemplate.OPEN_TYPE, current.clone() ) ),
            
            destroy: restrict( roleAC, 

                () => {
                    if (roleA.includes( Config.role() ))
                        return true;

                    // can see only "my" types: with cluster == my cluster;
                    // there are only global and "my" types in the list;
                    // so, let's check only presence of cluster in type
                    // to separate "my".
                    return !!this.options.paged
                        .current().get( 'cluster' );
                },

                current => {
                    const { page } = this.state();
                    // length will be updated by "destroy" call on model
                    const length = this.options.paged.length;

                    ask( 'type::modal delete - confirmation text',
                        'type::modal delete - title', 'actions::yes', 'actions::no',
                        () => this.options.source.destroy( current ) )
                        .then( () => {
                            if (length === 1 && page > 1)
                                    this.setState( { page: page - 1, } );
                        } )
                        .then( () => this.sort() )
                        .then( () => this.render() )
                        .then( () => this.navigated() );
                } )
        };

        this.options.filter = new FilterModel( { 
            cluster: this.state().cluster,
        } )
        this.options.source = new Types( this.options.types.models );
        this.options.sorted = new Types();
        this.options.filtered = new Types();
        this.options.paged = new Types( { actions, } );

        return this.sort().then( () => this.bind( this.options.filter ) );
    },

    // need to override to pass typeGroups to grid
    serialize() {
        return {
            ...RefBooksList.prototype.serialize.call( this ),
            typeGroups: this.options.typeGroups
        }
    }

} );



// WEBPACK FOOTER //
// ./src/js/module/refbooks/types.list.js